import { useCallback, useEffect, useState } from 'react';
import { getWikiPage } from 'api';

export const useWikiPage = (pageId) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!pageId) return;
    try {
      setLoading(true);
      setError(null);
      setPage(await getWikiPage(pageId));
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [pageId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { page, loading, error, refresh };
};
